module.exports = __webpack_public_path__ + "img/thumb-video-morro.88c63abf.jpg";